export default __webpack_public_path__ + "static/media/CapaFileName.16c6bbee.svg";